import { createContext } from 'react'
import type { Store } from 'components/common/filters/select-store'

export interface StoreTrajectoryState {
  storeId: number | null
  store: Store | null
  referenceYear: number | null
  setReferenceYear: (referenceYear: number | null) => void
  targetYear: number | null
  setTargetYear: (targetYear: number | null) => void
  referenceStoreId: number | null
  setReferenceStoreId: (referenceStoreId: number | null) => void
  referenceStore: Store | null

  forecastInstoreGmv: number | null
  setForecastInstoreGmv: (forecastInstoreGmv: number | null) => void
  isForecastInstoreGmvValid: boolean
  forecastInstoreMarginRate: number | null
  setForecastInstoreMarginRate: (forecastInstoreMarginRate: number | null) => void
  isForecastInstoreMarginRateValid: boolean
  forecastInstoreSellingPrice: number | null
  setForecastInstoreSellingPrice: (forecastInstoreSellingPrice: number | null) => void
  isForecastInstoreSellingPriceValid: boolean
  forecastInstoreQuantities: number | null
  setForecastInstoreQuantities: (forecastInstoreQuantities: number | null) => void

  forecastInstorePhysical: number | null
  setForecastInstorePhysical: (forecastInstorePhysical: number | null) => void
  forecastInstoreDigital: number | null
  setForecastInstoreDigital: (forecastInstoreDigital: number | null) => void
  forecastInstoreDecapro: number | null
  setForecastInstoreDecapro: (forecastInstoreDecapro: number | null) => void

  forecastInstoreCircular: number | null
  setForecastInstoreCircular: (forecastInstoreCircular: number | null) => void
  forecastInstoreNonCircular: number | null
  setForecastInstoreNonCircular: (forecastInstoreNonCircular: number | null) => void

  forecastInstoreRepair: number | null
  setForecastInstoreRepair: (forecastInstoreRepair: number | null) => void
  forecastInstoreSecondLife: number | null
  setForecastInstoreSecondLife: (forecastInstoreSecondLife: number | null) => void
  forecastInstoreBuyBack: number | null
  setForecastInstoreBuyBack: (forecastInstoreBuyBack: number | null) => void
  forecastInstoreRental: number | null
  setForecastInstoreRental: (forecastInstoreRental: number | null) => void

  forecastOutstoreGmv: number | null
  setForecastOutstoreGmv: (forecastOutstoreGmv: number | null) => void
  isForecastOutstoreGmvValid: boolean
  forecastOutstoreMarginRate: number | null
  setForecastOutstoreMarginRate: (forecastOutstoreMarginRate: number | null) => void
  isForecastOutstoreMarginRateValid: boolean
  forecastOutstoreSellingPrice: number | null
  setForecastOutstoreSellingPrice: (forecastOutstoreSellingPrice: number | null) => void
  isForecastOutstoreSellingPriceValid: boolean
  forecastOutstoreQuantities: number | null
  setForecastOutstoreQuantities: (forecastOutstoreQuantities: number | null) => void
  toAccountValues: () => {
    instore: {
      digital_gmv: number | null
      physical_gmv: number | null
      decapro_gmv: number | null
      eco_circular_repair_and_maintenance_gmv: number | null
      eco_circular_saved_products_gmv: number | null
      eco_circular_buy_back_gmv: number | null
      eco_circular_rental_gmv: number | null
      margin_rate: number | null
      quantity: number | null
    }
    outstore: {
      gmv: number | null
      margin_rate: number | null
      quantity: number | null
    }
  }
  areForecastValuesValid: () => boolean
  areInstoreGmvSegmentsTotalUnderAllocated: () => boolean
  areInstoreGmvSegmentsTotalOverAllocated: () => boolean
  salesChannelsPercentTotal: number | null
  setSalesChannelsPercentTotal: (salesChannelsPercentTotal: number | null) => void
  typeOfEconomyPercentTotal: number | null
  setTypeOfEconomyPercentTotal: (typeOfEconomyPercentTotal: number | null) => void
  circularPercentTotal: number | null
  setCircularPercentTotal: (circularPercentTotal: number | null) => void
}

export const StoreTrajectoryContext = createContext<StoreTrajectoryState | undefined>(undefined)
